"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = speakableActivity;

function speakableActivity(activity) {
  return activity && activity.from && activity.type === 'message';
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzcGVha2FibGVBY3Rpdml0eSIsImFjdGl2aXR5IiwiZnJvbSIsInR5cGUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZGVmaW5pdGlvbnMvc3BlYWthYmxlQWN0aXZpdHkuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc3BlYWthYmxlQWN0aXZpdHkoYWN0aXZpdHkpIHtcbiAgcmV0dXJuIGFjdGl2aXR5ICYmIGFjdGl2aXR5LmZyb20gJiYgYWN0aXZpdHkudHlwZSA9PT0gJ21lc3NhZ2UnO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQWUsU0FBU0EsaUJBQVQsQ0FBMkJDLFFBQTNCLEVBQXFDO0VBQ2xELE9BQU9BLFFBQVEsSUFBSUEsUUFBUSxDQUFDQyxJQUFyQixJQUE2QkQsUUFBUSxDQUFDRSxJQUFULEtBQWtCLFNBQXREO0FBQ0QifQ==